import React, {useState, useEffect} from 'react';
import SubscriptionTable from './SubscriptionTableComp';
import StaticNav from '../common/StaticNav';
import { connect } from 'react-redux';
import { Redirect} from 'react-router-dom';
import { convertDictionaryKeys } from '../../Utils';

const SubscriptionPage = ({database, programs}) => {
  const [hasDatabaseData, sethasDatabaseData] = useState(true);
  useEffect(() => {
    if(!database['getCustomer'])
      return sethasDatabaseData(false);
  });

  if (!hasDatabaseData) { return <Redirect to='/' />;}  

  return (
    <div>
        <br/>
        <StaticNav currentTopic={'Subscriptions'}/>     
        <SubscriptionTable pageState={{programs, ownedPrograms:database['getAllPrograms'], customer:database['getCustomer']}}/>
    </div>
  );
};

const mapStateToProps = state => {
  return {
      isAdmin: (state.dashboardReducer.login === 'Admin'),
      database: state.genericReducer,
      programs: convertDictionaryKeys(state.rawProgramReducer.programs, 'id') 
  };
};

export default connect(mapStateToProps)(SubscriptionPage);
